import axiosInstance, {
  analyticsInstance,
  axiosAuthInstance,
  builderInstance,
} from 'api/base';
import {
  normalizeAnalyticsDictionaries,
  normalizeAuthDictionaries,
  normalizeBuilderDictionaries,
  normalizeDictionaries,
  normalizeRoles,
} from 'api/data/normalizers';
import {
  IAnalyticDictionaries,
  IAuthDictionaries,
  IBuilderDictionaries,
  IDictionaries,
  IRole,
  IRolesParams,
} from 'api/data/types';

const dataAPI = {
  async getDictionaries(): Promise<IDictionaries> {
    const response = await axiosInstance.get('dictionaries');

    return normalizeDictionaries(response.data?.dictionaries);
  },

  async getRoles(params?: IRolesParams): Promise<IRole[]> {
    const response = await axiosAuthInstance.get('roles', { params });

    return normalizeRoles(response.data);
  },

  async getAnalyticsDictionaries(): Promise<IAnalyticDictionaries> {
    const response = await analyticsInstance.get('dictionaries');

    return normalizeAnalyticsDictionaries(response.data?.dictionaries);
  },

  async getAuthDictionaries(): Promise<IAuthDictionaries> {
    const response = await axiosAuthInstance.get('dictionaries');

    return normalizeAuthDictionaries(response.data?.dictionaries);
  },

  async getBuilderDictionaries(): Promise<IBuilderDictionaries> {
    const response = await builderInstance.get(`dictionaries`);

    return normalizeBuilderDictionaries(response.data?.dictionaries);
  },
};

export default dataAPI;
